import React from "react";
import { Breadcrumbs, Link } from "@repo/ui";
import NextLink from "next/link";
import StructuredData from "./StructuredData";

type BreadcrumbsLinkProps = {
  breadcrumbs: BreadcrumbsType[];
  className?: string;
};

const BreadcrumbsLink = ({
  breadcrumbs = [],
  className,
}: BreadcrumbsLinkProps) => {
  const breadcrumbSchema = React.useMemo(() => {
    return {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: breadcrumbs?.map((item, index, items) => ({
        "@type": "ListItem",
        position: index + 1,
        name: item.label,
        ...(index + 1 !== items.length &&
          item.url && {
            item: process.env.NEXT_PUBLIC_APP_URL + item.url,
          }),
      })),
    };
  }, [breadcrumbs]);
  if (!breadcrumbs.length) return null;
  return (
    <>
      <Breadcrumbs className={className}>
        {breadcrumbs.map((item, index) => (
          <Link
            key={`bread-crumbs-${index}`}
            className="!text-xs sm:!text-sm"
            render={
              item.url ? (
                <NextLink href={item.url ? item.url : "#"} />
              ) : (
                <span />
              )
            }
          >
            {item.label}
          </Link>
        ))}
      </Breadcrumbs>
      <StructuredData data={breadcrumbSchema} />
    </>
  );
};

export default BreadcrumbsLink;
